import { getLoginUrl } from "@/lib/utils/routing";
import { NavLink, ThemeIcon } from "@mantine/core";
import ArticleRounded from "@mui/icons-material/ArticleRounded";
import BackupTableRoundedIcon from "@mui/icons-material/BackupTableRounded";
import Diversity1Rounded from "@mui/icons-material/GroupRounded";
import InfoRounded from "@mui/icons-material/InfoRounded";
import LoginRounded from "@mui/icons-material/LoginRounded";
import PersonAddRounded from "@mui/icons-material/PersonAddRounded";
import StarRounded from "@mui/icons-material/StarRounded";
import WorkspacePremiumRounded from "@mui/icons-material/WorkspacePremiumRounded";
import Link from "next/link";
import { CSSProperties, Dispatch, SetStateAction } from "react";
import clsx from "clsx";
import { capFirst } from "../../../../../lib/strapi/formatters";
import classes from "./AboutLinks.module.css";
import { useMenuStles } from "./SubjectLinks";

export default function AboutLink({
  iconSize,
  link,
  opened,
  setOpened,
}: {
  iconSize: number;
  link:
    | "about"
    | "blog"
    | "team"
    | "login"
    | "register"
    | "#resources"
    | "pricing"
    | "#reviews";
  opened: boolean;
  setOpened: Dispatch<SetStateAction<boolean>>;
}) {
  const { classes: menuClasses } = useMenuStles();
  const color = "lightblue";
  const iconStyle = { width: iconSize, height: iconSize };
  let icon;
  let label = capFirst(link);
  switch (link) {
    case "about":
      icon = <InfoRounded style={iconStyle} />;
      break;
    case "blog":
      icon = <ArticleRounded style={iconStyle} />;
      label = "Blog";
      break;
    case "team":
      icon = <Diversity1Rounded style={iconStyle} />;
      label = "Team";
      break;
    case "#reviews":
      icon = <StarRounded style={iconStyle} />;
      label = "Reviews";
      break;
    case "pricing":
      icon = <WorkspacePremiumRounded style={iconStyle} />;
      label = "Pricing";
      break;
    case "#resources":
      icon = <BackupTableRoundedIcon style={iconStyle} />;
      label = "Resources";
      break;
    case "login":
      icon = <LoginRounded style={iconStyle} />;
      break;
    case "register":
      icon = <PersonAddRounded style={iconStyle} />;
      break;
  }
  const isLoginLink = link === "login";

  const themeIconStyle = {
    "--theme-icon-bg-light": `var(--mantine-color-${color}-5)`,
    "--theme-icon-bg-dark": `var(--mantine-color-${color}-6)`,
  } as CSSProperties;

  return (
    <NavLink
      className={clsx(menuClasses.overallLink, classes.navLinkLabel)}
      label={label}
      aria-label={label}
      leftSection={
        <ThemeIcon
          aria-label={label}
          className={classes.themeIcon}
          style={themeIconStyle}
        >
          {icon}
        </ThemeIcon>
      }
      onClick={(e: any) => {
        opened && setOpened(false);
        if (isLoginLink) {
          e.preventDefault();
          if (typeof window !== "undefined") {
            window.location.href = getLoginUrl();
          }
        }
      }}
      component={Link}
      href={link === "blog" ? "/blog" : `/${link}`}
      variant="light"
      color={color}
    />
  );
}
